import angular from 'angular';

import Component from './coupon-manage.component';

const CouponManage = angular
    .module('control-room.experience-promoter.components.coupon-manage', [])
    .component('crCouponManage', Component);

export default CouponManage;
